var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"excavate-association"},[_vm._m(0),_c('analysisOption',{on:{"option_click":_vm.option_click}}),_c('div',{staticClass:"flex-end"},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.association_click}},[_vm._v("社团分析")])],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"excavate-tip"},[_c('span'),_vm._v(" 颜色相同的标记为同一类，对应的是表格中显示clusterId 相同的表示同一类。")])
}]

export { render, staticRenderFns }